import { Grid, Card, CardContent, Box, Button, Drawer, Typography, IconButton } from "@mui/material";
import PageTitle from "../../components/PageTitle";
import { useState } from "react";
import HolidayListUpload from "./HolidayListUpload";
import HolidayListAdd from "./HolidayListAdd";
import HolidayListView from "./HolidayListView";
import { Upload as UploadIcon, Add as AddIcon, Close as CloseIcon } from "@mui/icons-material";

export default function HolidayList() {
    const [uploadOpen, setUploadOpen] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleSuccess = (type) => {
        if (type === 'upload') setUploadOpen(false);
        if (type === 'add') setAddOpen(false);
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <>
            <PageTitle>Holiday List</PageTitle>
            <Grid paddingBottom={2}>
                <Card>
                    <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2 }}>
                            <Button
                                variant="contained"
                                color="warning"
                                size="small"
                                startIcon={<UploadIcon />}
                                onClick={() => setUploadOpen(true)}
                            >
                                Upload Holidays
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<AddIcon />}
                                onClick={() => setAddOpen(true)}
                            >
                                Add Holidays
                            </Button>
                        </Box>

                        <HolidayListView refreshKey={refreshKey} />
                    </CardContent>
                </Card>
            </Grid>

            {/* Upload Sidebar */}
            <Drawer anchor="right" open={uploadOpen} onClose={() => setUploadOpen(false)}>
                <Box sx={{ width: '50vw', p: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6">Upload Holiday List</Typography>
                        <IconButton onClick={() => setUploadOpen(false)} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <HolidayListUpload onSuccess={() => handleSuccess('upload')} />
                </Box>
            </Drawer>

            {/* Add Sidebar */}
            <Drawer anchor="right" open={addOpen} onClose={() => setAddOpen(false)}>
                <Box sx={{ width: '50vw', p: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6">Add Holiday List</Typography>
                        <IconButton onClick={() => setAddOpen(false)} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <HolidayListAdd onSuccess={() => handleSuccess('add')} />
                </Box>
            </Drawer>
        </>
    )
}
